/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Activation_Code_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter your activation code" |
*
* @param {Login_Offline_Activation_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activation_code_placeholder = /** @type {((inputs?: Login_Offline_Activation_Code_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activation_Code_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entrez votre code d'activation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie Ihren Aktivierungscode ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci il tuo codice di attivazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите свой код активации")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca su código de activación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入您的激活码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アクティベーションコードを入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपना एक्टिवेशन कोड दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira seu código de ativação")
	return /** @type {LocalizedString} */ ("Enter your activation code")
});